import React from 'react'
import classNamesBind from 'classnames/bind'
import isMobile from 'is-mobile'

import ReactiveOverlay from '@dashboard/components/ReactiveOverlay'

import { typeTraits } from '@dashboard/lib/personality'
import { oxfordComma } from '@dashboard/lib/string'
import { DiscPercentages, DiscType, Profile } from '@dashboard/lib/types'
import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  profile: Profile
  height: number
  hasBreakdown: boolean
}

export default class BarGraph extends React.Component<OwnProps> {
  // Render
  render() {
    const { height } = this.props
    const values = this.fourPercentages()

    return (
      <div
        className={classNames('container')}
        style={{ height: `${height}px` }}
      >
        {this.renderDiscColumn('D', values.d)}
        {this.renderDiscColumn('I', values.i)}
        {this.renderDiscColumn('S', values.s)}
        {this.renderDiscColumn('C', values.c)}
        <div className={classNames('letter', 'D')}>D</div>
        <div className={classNames('letter', 'I')}>I</div>
        <div className={classNames('letter', 'S')}>S</div>
        <div className={classNames('letter', 'C')}>C</div>
        <div className={classNames('percentage', 'D')}>{values.d}%</div>
        <div className={classNames('percentage', 'I')}>{values.i}%</div>
        <div className={classNames('percentage', 'S')}>{values.s}%</div>
        <div className={classNames('percentage', 'C')}>{values.c}%</div>
      </div>
    )
  }

  // Partials
  renderDiscColumn(discType: DiscType, amount: number) {
    const style: React.CSSProperties = {
      height: `${Math.max(4, amount)}%`,
      alignSelf: 'flex-end',
      marginBottom: '10px',
    }

    return (
      <ReactiveOverlay
        containerStyles={style}
        overlayContent={this.renderTraits(discType)}
        overlayGap={8}
        preferredDirection={isMobile() ? 'topLeft' : 'topRight'}
      >
        <div className={classNames('bar', discType)} />
      </ReactiveOverlay>
    )
  }

  renderTraits(discType: DiscType) {
    return (
      <div
        className={classNames('hover-traits', discType)}
        onClick={() => this.setState({ selectedType: null })}
      >
        <div className={classNames('hover-title', discType)}>{discType}</div>
        <div className={classNames('hover-title')}>
          {oxfordComma(typeTraits(discType))}
        </div>
      </div>
    )
  }

  fourPercentages(): DiscPercentages {
    const { profile } = this.props

    if (!profile.personality?.four_percentages)
      return { d: 0, i: 0, s: 0, c: 0 }

    return profile.personality?.four_percentages
  }
}
